var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('simple',{scopedSlots:_vm._u([{key:"beforeFooter",fn:function(){return [_c('client-only',[_c('RecentlyProducts',{attrs:{"ids-excluded":_vm.idsExcluded}}),_vm._v(" "),_c('RecentlyViewedCategories')],1)]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }